<template>
  <form novalidate>
    <h4 class="h4 text--bold text--uppercase">Datos del funcionario en campo</h4>
    <form-group :error="errors.has('hora-inicio')">
      <datetime
        v-model="form.horaInicio"
        v-validate="'required'"
        :disabled="!editando"
        :use12-hour="true"
        format="t"
        input-class="form__input"
        name="hora-inicio"
        ref="horaInicio"
        title="Hora de inicio"
        type="time"
        value-zone="local"
      />
      <label class="form__label form__label--required">
        Hora de inicio de la gira
      </label>
    </form-group>
    <form-group :error="errors.has('fecha-reporte')">
      <datetime
        :disabled="!editando"
        v-model="form.fechaReporte"
        v-validate="'required'"
        :use12-hour="true"
        input-class="form__input"
        name="fecha-reporte"
        value-zone="local"
        type="date"/>
      <label class="form__label form__label--required">
        1. Fecha en que se recibió el reporte
      </label>
    </form-group>
    <form-group :error="errors.has('informante')">
      <input
      data-vv-validate-on="blur"
      :disabled="!editando"
      type="text"
      class="form__input"
      v-model="form.nombreInformante"
      name="informante"
      required
      v-validate="'required'">
      <label class="form__label form__label--required">2. Nombre del informante del evento</label>
    </form-group>
    <form-group :error="errors.has('fecha-visita')">
      <datetime
        :disabled="!editando"
        v-model="form.fechaVisitaCampo"
        v-validate="'required'"
        :use12-hour="true"
        input-class="form__input"
        name="fecha-visita"
        value-zone="local"
        type="date"/>
      <label class="form__label form__label--required">3. Fecha de la visita de campo</label>
    </form-group>
    <div class="form__group">
      <label class="form__label form__label--required">4. Nombre del funcionario o entrevistador
      </label>
      <p class="text">{{ form.inspector.nombre }} {{ form.inspector.apellidos }}</p>
    </div>
    <div class="form__group">
      <label class="form__label form__label--required">5. Oficina o ASP</label>
      <p class="text">{{ form.inspector.oficina }}</p>
    </div>
    <div class="form__group">
      <label class="form__label form__label--required">6. Área de conservación</label>
      <p class="text">{{ form.inspector.areaConservacion }}</p>
    </div>
  </form>
</template>

<script>
import moment from "moment";

export default {
  name: "FormularioHeader",
  props: {
    editando: Boolean,
    submitted: Boolean,
    form: Object,
  },
  methods: {
    validar,
  },
  mounted() {
    if (this.editando && !this.form.horaInicio) {
      this.form.horaInicio = moment().format();
      this.$refs.horaInicio.isOpen = true;
    }
  },
};

function validar() {
  return this.$validator.validate();
}
</script>
